import {CollapsibleContent} from '../../components/collapsible-content';

import ContentBlocksInCollapsible from './ContentBlocksInCollapsible';
import {type CollapsibleContentFragment} from './query';

type Props = {
	data: CollapsibleContentFragment;
	fullWidth?: boolean;
	insideToc?: boolean;
};

export const CollapsibleContentContainer = ({data, fullWidth, insideToc}: Props) => {
	const {heading, description, contentBlockOptions, content} = data;

	if (!content) {
		return null;
	}

	return (
		<CollapsibleContent
			heading={heading ?? 'Mangler overskrift'}
			description={description}
			options={{fullWidth, ...contentBlockOptions}}
			insideToc={insideToc}
		>
			{content && content.length > 0 && <ContentBlocksInCollapsible content={content} />}
		</CollapsibleContent>
	);
};
